module.exports = __webpack_public_path__ + "img/top-bannar.80efba0.png";